<template>
  <div class="chart_box" :style="{ width: '93%', height: barBoxHeight + 'px' }">
    <div
      :style="{ width: '100%', height: barChartHeight + 'px' }"
      ref="barChartRef"
    ></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  props: {
    viewLeft: {
      type: Object,
      required: true,
    },
  },
  name: "PieLog",
  data() {
    return {
      option: {
        title: {
          text: "",
          left: "center",
          textStyle: {
            color: "#FFF",
          },
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        legend: {
          bottom: 10,
          left: "center",
          data: [],
          textStyle: {
            fontSize: 15,
            color: "#FFF",
          },
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: "65%",
            center: ["50%", "50%"],
            selectedMode: "single",
            itemStyle: {
              color: (params) => {
                const colorList = [];
                return colorList[params.dataIndex % colorList.length];
              },
            },
            normal: {
              label: {
                show: true,
                fontSize: 15,
                color: "#FFF",
              },
            },
            data: [],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      },
      screenWidth: 0,
      screenHeight: 0,
      barChartHeight: 380,
      barBoxHeight: 450,
    };
  },
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize());
  },
  methods: {
    handleResize() {
      console.log("窗口大小变化，handleResize方法被调用了");
      this.screenWidth = window.innerWidth;
      this.screenHeight = window.innerHeight;
      this.barBoxHeight = (this.screenHeight - 170) / 2;

      const echart = echarts.init(this.$refs.barChartRef);
      this.barChartHeight = this.screenHeight / 2 - 80;
      // 更新饼图容器的样式
      this.$refs.barChartRef.style.height = this.barChartHeight + "px";
      this.option.title.text = this.viewLeft.item_name;
      this.option.legend.data = this.viewLeft.item_xdata;
      this.option.series[0].name = this.viewLeft.item_name;
      this.option.series[0].data = this.viewLeft.series_data;
      if (this.viewLeft.colorList && Array.isArray(this.viewLeft.colorList)) {
        this.option.series[0].itemStyle.color = (params) => {
          return this.viewLeft.colorList[
            params.dataIndex % this.viewLeft.colorList.length
          ];
        };
      }
      echart.resize();
      echart.setOption(this.option);
    },
  },
  beforeDestroy() {
    // 在组件销毁前移除窗口大小变化的监听器，以防止内存泄漏
    window.removeEventListener("resize", this.handleResize());
  },
};
</script>

<style scoped>
.chart_box {
  box-shadow: 0 0 30px 0 rgba(0, 128, 202, 0.8) inset;
  border-radius: 0.02rem;
  margin: 20px;
  padding: 10px;
}
</style>
